import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Wrench } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="space-y-6" data-testid="about-page">
      <div className="text-center py-8">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-[#0052CC] rounded-2xl flex items-center justify-center shadow-lg">
            <Wrench className="w-12 h-12 text-white" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold text-slate-900 mb-2">Maintix</h1>
        <p className="text-lg text-slate-600 mb-8">Smart Maintenance & Asset Control</p>
        
        <Card className="card-industrial max-w-lg mx-auto">
          <CardContent className="p-8 text-left">
            <p className="text-slate-700 leading-relaxed mb-6">
              Maintix is an enterprise-grade platform for industrial maintenance,
              asset management and operational control, designed for multi-factory
              and multi-location environments.
            </p>
            
            <div className="border-t border-slate-200 pt-6">
              <p className="text-sm text-slate-500 mb-2">Designed & developed by</p>
              <p className="text-lg font-semibold text-slate-900">Daniel Morosanu</p>
            </div>
          </CardContent>
        </Card>
        
        <div className="mt-8 text-sm text-slate-400">
          <p>Version 1.0.0</p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
